module.exports = __webpack_public_path__ + "img/log_qrcode.d65132ed.png";